const localizers = {
  'loading.msg': () => `Загрузка...`,
  'SASServer.genericError.msg': () => `Невозможно связаться с сервером.`,
  'SASReport.genericError.msg': () => `Не удалось загрузить выбранный отчет.`,
  'SASReportImage.genericError.msg': () => `Не удалось загрузить изображение отчета.`,
  'SASReportImage.imageNotSupported.msg': () => `Изображения не поддерживаются для этого типа содержимого отчета.`,
}
export default localizers;
